import { render, staticRenderFns } from "./CytomineViewer.vue?vue&type=template&id=2fec1f5c&scoped=true"
import script from "./CytomineViewer.vue?vue&type=script&lang=js"
export * from "./CytomineViewer.vue?vue&type=script&lang=js"
import style0 from "./CytomineViewer.vue?vue&type=style&index=0&id=2fec1f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec1f5c",
  null
  
)

export default component.exports